import { Component } from "@angular/core";

@Component({
  selector: 'kt-outseta-ticket-popup',
  templateUrl: './outseta-ticket-popup.component.html'
})
export class OutsetaTicketPopupComponent {}